"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CreditCardModal = void 0;
const React = require("react");
const Modal_1 = require("../../../base/structure/Modal");
const dialogs_1 = require("../../../../types/dialogs");
const PayDockCreditCardForm_1 = require("../../payments/PayDockCreditCardForm");
/**
 * Component rendering a PayDock form modal
 */
const CreditCardModal = ({ open = true, onClose, onSuccess, disclaimer }) => {
    return (React.createElement(Modal_1.Modal, { open: open, onClose: onClose ? onClose : null, size: dialogs_1.TDialogSizes.Medium },
        React.createElement(Modal_1.ModalHeader, null, "Credit card details (CreditCardModel)"),
        React.createElement(Modal_1.ModalBody, null,
            React.createElement(PayDockCreditCardForm_1.PayDockCreditCardForm, { onSuccess: onSuccess, disclaimer: disclaimer }))));
};
exports.CreditCardModal = CreditCardModal;
//# sourceMappingURL=index.js.map